
import {defineComponent} from 'vue';
import {mergeClass} from '@/scss/StyleClassManager';
import {BlockItemAction} from "@/models/Blocks/Itens/Types/block-content-types";
import Rating from "@/components/Muffin/Rating.vue";

export default defineComponent({
    components: {Rating},
    props: {
        starRating: {
            type: [Object, null],
            default: {
                rating: 0,
                kStrings: null
            }
        }
    },
    computed: {
        roundedStarRating(): number {
            return Math.round((this.starRating.rating / 2) * 10) / 10;
        },
        ratingLabel(): string {
            if (this.starRating.rating > 0) {
                return this.roundedStarRating + ' / 5';
            }

            if(!this.starRating.overrideLabel) {
                return this.starRating.kStrings ? this.starRating.kStrings.kGLOB_NEW : 'New';
            }
            
            return this.starRating.overrideLabel;
        }
    },
});
